import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Tiles from './Tiles.js'
import Menu from './Menu.js'
import FAQ from './FAQ.js'
import Parcours from './Parcours.js'
import '../node_modules/popper.js';
import '../node_modules/jquery/dist/jquery';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min';
import liste from './Data.js';

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'


class App extends Component {

  render() {
    const Home = () => (
      <div className="App">
        <div id="mySidenav" className="sidenav">
          <Menu liste={liste} periode={1} periode='0' />
        </div>
        <div id="main" class="text-center">
        <div class="container">
  <div className="row">
  <div className="col-sm"><img className="img-fluid PhotoHomepage" src={require('./ressources/jsg1968.JPG')} alt="1968" /></div>
  <div className="col-sm"><img className="img-fluid PhotoHomepage" src={require('./ressources/jsg.jpg')}  alt="1993" /></div>
  <div className="col-sm"><img  className="img-fluid PhotoHomepage" src={require('./ressources/jsgalego.jpg')}  alt="2016" /></div>

  </div>
    <div className="row">
    <div className="col-sm"><small className="text-center">1968</small></div>
    <div className="col-sm"><small className="text-center">1993</small></div>
    <div className="col-sm"><small className="text-center">2016</small></div>
    </div>
  </div>

          <p class="presentation">Site de présentation des périodes et œuvres les plus caractéristiques parmis les milliers de créations de dessins, peintures, sculptures, gravures créés par Jorge Sancho Galego et qui révèlent son gout et devoir de renouvellement Artistique sans se soucier des modes, tendances qui frôlent son parcours...</p>
          <img className="img-fluid" src={require('./ressources/jsg2016.png')} /><br />
          <small>© Copyright ADAGP/JSG</small><br />
          <span className="subtitle">Les photos sont en basse résolution afin d'éviter les reproductions</span>
        </div> 
      </div>
);

const Contact = (props) => (
  <div className="App">
    <div id="mySidenav" className="sidenav">
      <Menu liste={liste} />
    </div>
    <div id="main">
    <div className="titre">Contact</div>

        <p>Le site est destiné à la connaissance de l'Artiste,
    Les amateurs d'art et collectionneurs intéressés par des oeuvres sont invités à faire une offre de prix par mail.</p>
    email : jorge.galego.art@gmail.com

<br /><br />
    <h3>Internet</h3>

<a href="http://www.adagp.fr/fr/identities/jorge-galego-17331" target="_blank">www.adagp.fr</a><br />
<a href="http://www.dailymotion.com/jorgegalego" target="_blank">www.dailymotion.com/jorgegalego</a> (Création vidéos)<br />
<a href="http://www.lamaisondesartistes.fr" target="_blank">www.lamaisondesartistes.fr</a><br />
<a href="https://www.artistescontemporains.org/membre/jorge-galego/" target="_blank">www.artistescontemporains.org</a><br />
<a href="https://www.saatchiart.com/jorgesanchogalego" target="_blank">www.saatchiart.com/jorgesanchogalego</a><br />
<a href="https://www.facebook.com/jorge.galego1/" target="_blank">www.facebook.com/jorge.galego1/</a>
    </div> 
    </div>
);


const faq_page = (props) => (
  <div className="App">
    <div id="mySidenav" className="sidenav">
      <Menu liste={liste} />
    </div>
    <div id="main">
        <FAQ />
    </div> 
  </div>
);


const parcours = (props) => (
  <div className="App">
    <div id="mySidenav" className="sidenav">
      <Menu liste={liste} />
    </div>
    <div id="main">
        <Parcours />
    </div> 
  </div>
);

const Periodes = (props) => (
  <div className="App">
    <div id="mySidenav" className="sidenav">
      <Menu liste={liste} id_periode={props.match.params.id} />
    </div>
    <div id="main">
      <Tiles liste={liste} periode={props.match.params.id} />
    </div> 
  </div>
);

    return (
<div>
      <Route exact path='/' component={Home} />
      <Route path="/periode/:id" component={Periodes} />
      <Route path="/contact" component={Contact} />
      <Route path="/parcours" component={parcours} />
      <Route path="/interview" component={faq_page} />
</div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js